module.exports = __webpack_public_path__ + "static/media/korfball.55290a6e.svg";